document.addEventListener('DOMContentLoaded', () => {
    const drawer = document.getElementById('NavDrawer');

    function initMegaMenus() {
      document.querySelectorAll('.mobile-mega-menu[data-menu-id]').forEach((menu) => {
        if (menu.dataset.initialized) return;
        menu.dataset.initialized = 'true';

        const tabs = menu.querySelectorAll('.mobile-mega-menu-tab');
        const panels = menu.querySelectorAll('.mobile-mega-menu-panel');

        tabs.forEach((tab, i) => {
          tab.onclick = () => {
            const target = menu.querySelector('#' + tab.dataset.target);
            tabs.forEach((t) => {
              t.classList.remove('active');
              t.setAttribute('aria-selected', 'false');
            });
            panels.forEach((p) => {
              p.classList.remove('active');
              p.setAttribute('aria-hidden', 'true');
            });
            tab.classList.add('active');
            tab.setAttribute('aria-selected', 'true');
            if (target) {
              target.classList.add('active');
              target.setAttribute('aria-hidden', 'false');
            }
          };
        });
      });
    }

    initMegaMenus();

    if (drawer) {
      new MutationObserver(() => {
        if (drawer.classList.contains('is-open')) initMegaMenus();
      }).observe(drawer, { attributes: true, attributeFilter: ['class'] });
    }
  });